
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/africa/speakers",
      function () {
        return require("private-next-pages/africa/speakers/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/africa/speakers"])
      });
    }
  